import { DEFAULT_SKIN, DEFAULT_SKIN_THEME } from '../constants/marketplace';
import { DomainBranding } from '../queries/marketplace';
import { Skin, SKIN, ThemeOption, THEME_OPTION } from '../types/enums';
import { getHostnameSegments } from '../utils/urlUtils';
import { SKIN_THEMES } from './themeConfig';

export type SkinConfig = {
  skin: Skin;
  theme: ThemeOption;
};

const KNOWN_SKINS: string[] = Object.values(SKIN);
const KNOWN_THEMES: string[] = Object.values(THEME_OPTION);
const MODERN_THEMES: ThemeOption[] = [THEME_OPTION.MODERN, THEME_OPTION.MODERN_GOLD, THEME_OPTION.MERKUR];

export const getDefaultSkinConfig = (skin: Skin = DEFAULT_SKIN): SkinConfig => ({
  skin,
  theme: DEFAULT_SKIN_THEME[skin],
});

export const isModernTheme = (theme: ThemeOption | undefined): boolean =>
  theme ? MODERN_THEMES.includes(theme) : false;

export const isKnownSkin = (skin: string): skin is Skin => KNOWN_SKINS.includes(skin);

export const isKnownTheme = (theme: string): theme is ThemeOption => KNOWN_THEMES.includes(theme);

export const isThemeValidForSkin = (theme: ThemeOption, skin: Skin): boolean =>
  SKIN_THEMES[skin].some((allowedTheme) => allowedTheme === theme);

export const resolveSkinConfig = (domains: DomainBranding[] | undefined): SkinConfig => {
  if (!domains?.length) {
    return getDefaultSkinConfig();
  }

  const matchedDomain = domains.find((domainConfig) => domainConfig.domain === getHostnameSegments().join('.'));

  if (!matchedDomain) {
    return getDefaultSkinConfig();
  }

  const { skin, theme } = matchedDomain.branding;

  if (!isKnownSkin(skin) || !isKnownTheme(theme) || !isThemeValidForSkin(theme, skin)) {
    return getDefaultSkinConfig();
  }

  return {
    skin,
    theme,
  };
};
